// extracted by mini-css-extract-plugin
export default {"StoreDashboard":"StoreDashboard_StoreDashboard__Z4gBS","Header":"StoreDashboard_Header__9jEhp","RightContainer":"StoreDashboard_RightContainer__23HaP"};